import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type NotificationRuleRow = {
  id: string;
  event_key: string;
  name: string;
  description: string | null;
  audience_segment_id: string | null;
  include_natural_recipient: boolean;
  mail_enabled: boolean;
  mail_subject_override: string | null;
  chat_enabled: boolean;
  chat_prefix_override: string | null;
  is_system: boolean;
  active: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
};

// GET /api/settings/notifications/rules — admin notification-rule board.
export function useNotificationRules() {
  return useQuery<NotificationRuleRow[], ApiClientError>({
    queryKey: queryKeys.settings.notificationRules(),
    queryFn: () =>
      apiFetch<NotificationRuleRow[]>("/settings/notifications/rules"),
  });
}
